import React, { memo } from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { TAG_ICON_OPTIONS } from '@/constants/admin/tagIcons';
import { useAdminColors } from '@/hooks/admin/useAdminColors';

interface TagIconPickerProps {
  selectedIcon: string | null;
  onSelectIcon: (icon: string | null) => void;
}

export const TagIconPicker: React.FC<TagIconPickerProps> = memo(
  ({ selectedIcon, onSelectIcon }) => {
    const { redesign, admin } = useAdminColors();

    return (
      <View style={styles.container}>
        <Text style={[styles.label, { color: redesign.text.secondary }]}>Icon</Text>
        <View style={styles.grid}>
          {TAG_ICON_OPTIONS.map(({ value, label, Component }) => {
            const isSelected = selectedIcon === value;
            return (
              <TouchableOpacity
                key={value}
                style={[
                  styles.iconCell,
                  {
                    backgroundColor: admin.formInput.bg,
                    borderColor: admin.formInput.border,
                  },
                  isSelected && {
                    borderColor: redesign.accent.blueBg,
                    borderWidth: 2,
                    backgroundColor: admin.selector.itemSelectedBg,
                  },
                ]}
                onPress={() => onSelectIcon(isSelected ? null : value)}
                activeOpacity={0.7}
                accessibilityLabel={label}
                accessibilityRole="radio"
                accessibilityState={{ selected: isSelected }}
              >
                <Component
                  width={20}
                  height={20}
                  color={isSelected ? redesign.accent.blueBg : redesign.text.primary}
                />
              </TouchableOpacity>
            );
          })}
        </View>
      </View>
    );
  },
);

TagIconPicker.displayName = 'TagIconPicker';

const styles = StyleSheet.create({
  container: {
    gap: 8,
  },
  label: {
    fontSize: 13,
    fontWeight: '500',
  },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  iconCell: {
    width: 40,
    height: 40,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
  },
});
